module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Loc":"Location"},"de":{"Loc":"Standort"}}')
  delete Component.options._Ctor
}
